import { render, staticRenderFns } from "./QuestionJudge.vue?vue&type=template&id=7f753d70&scoped=true&"
import script from "./QuestionJudge.vue?vue&type=script&lang=js&"
export * from "./QuestionJudge.vue?vue&type=script&lang=js&"
import style0 from "./QuestionJudge.vue?vue&type=style&index=0&id=7f753d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f753d70",
  null
  
)

export default component.exports